const groups = [
    {"groupName": "COPRA_PH_SlotBooking_ExternalUser", "lang": "ph"},
    {"groupName": "DXP_CACP_ExternalUsers", "lang": "aus"}
]

export default {
  getGroup(group) {
    var val = groups.filter(x => x.groupName.indexOf(group) > -1)
    if (val.length > 0) {
      return val
    } else {
      return -1
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/country-code.js